import { Link } from 'react-router'

export default function Footer() {
  // oxlint-disable-next-line react/purity -- copyright year only needs to be current per render
  const year = new Date().getFullYear()

  return (
    <div className='border-border text-muted-foreground mx-3 my-2 flex flex-col items-center justify-between border-t pt-8 text-sm md:flex-row'>
      <p>© {year} Akadenia. All rights reserved.</p>
      <div className='mt-4 flex space-x-4 md:mt-0'>
        <span>
          Powered by{' '}
          <Link
            to='https://akadenia.com'
            className='hover:text-primary transition-colors'
          >
            Akadenia
          </Link>
        </span>
      </div>
    </div>
  )
}
